'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionReviewingService', function ($rootScope,
                                                    TransactionsModel,
                                                    TransactionRepository) {
    var self = this;
    var TRANSACTION_REVIEWED = 'transaction_reviewed';

    self.getUpdatedReviewedStatus = function(transaction) {
      return _.get(transaction, 'mutableTransactionProperties.transactionStatus');
    };

    self.markTransactionsAsReviewed = function(transactions) {
      var transactionsToUpdate =[];
      TransactionsModel.loading(true);

      for(var i = 0; i < transactions.length; i++){
        var transaction = transactions[i];
        if (transaction.lockStatus !== 'FULLY_LOCKED' && self.getUpdatedReviewedStatus(transaction) === 'NOT_REVIEWED' ) {
          transactionsToUpdate.push({
            reviewed: true,
            id: transaction.id
          });
        }
      }

      if (transactionsToUpdate.length > 0) {
        TransactionRepository.updateTransactions(transactionsToUpdate)
          .then(function () {
            $rootScope.$broadcast(TRANSACTION_REVIEWED);
            TransactionsModel.refreshTransactions(_.map(transactionsToUpdate, 'id'));
            TransactionsModel.loading(false);
          })
          .catch(function () {
            TransactionsModel.loading(false);
          });
      }
    };

    self.markTransactionsAsUnreviewed = function(transactions) {
      var transactionsToUpdate =[];

      TransactionsModel.loading(true);

      for(var i = 0; i < transactions.length; i++){
        var transaction = transactions[i];
        transactionsToUpdate.push({
          id: transaction.id,
          reviewed: false
        });
      }

      TransactionRepository.updateTransactions(transactionsToUpdate)
        .then(function () {
          $rootScope.$broadcast(TRANSACTION_REVIEWED);
          TransactionsModel.refreshTransactions(_.map(transactionsToUpdate, 'id'));
          TransactionsModel.loading(false);
        })
        .catch(function () {
          TransactionsModel.loading(false);
        });
    };

    self.onTransactionReviewed = function (scope, handler) {
      scope.$on(TRANSACTION_REVIEWED, function () {
        handler();
      });
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionReviewingService.js
// module id = 653
// module chunks = 0